var collator = new Intl.Collator('en', {
  sensitivity: 'base',
  numeric: true
});
export var locationNameAlphaSort = (results, store) => results.sort((a, b) => collator.compare(b.locationName, a.locationName));
//# sourceMappingURL=sort.js.map